/** Підписи платформи для стандартних полів ключового рядка (прототип v4: «Assigned to: · Status: · Priority: · Deadline:»). */
const LABELS: Readonly<Record<string, string>> = {
  assignee: 'recordPage.assigneeLabel', status: 'form.status', priority: 'form.priority', due: 'form.due',
};

/** Ключ перекладу мітки поля ключового рядка: стандартне поле — підпис платформи; інше — undefined (підпис поля типу). Чиста функція. */
export function keyLineLabelKey(key: string): string | undefined {
  return LABELS[key];
}
